module.exports = __webpack_public_path__ + "img/좌진규 아티스트.f6f75d5a.jpg";